export const calculateArea = (percentageArea, area) => {
  const calculatedArea = (area * percentageArea) / 100;
  return parseFloat(calculatedArea?.toFixed(2));
};

export const relativeToTheTotalArea = (percentageArea, parameterMapInfo) => {
  if (parameterMapInfo?.ranges?.length >= 2) {
    if (percentageArea === 0) {
      return "کمتر از 1";
    } else if (percentageArea === 100) {
      return "بیشتر از 99";
    } else {
      return percentageArea;
    }
  } else {
    return percentageArea;
  }
};

export const proposition1UiHelper = (name, parameterMapInfo) => {
  let parameterValue = 0;
  parameterMapInfo?.mapInfo?.ranges?.forEach((range, i) => {
    parameterValue +=
      ((range?.max + range?.min) / 2) *
      parameterMapInfo?.mapInfo?.percentage[i];
  });
  parameterValue /= 100;
  if (name === "pH") {
    if (parameterValue > 0 && parameterValue < 6.9) {
      return "با pH اسیدی";
    }
    if (parameterValue > 6.9 && parameterValue < 7.1) {
      return "با pH خنثی";
    }
    if (parameterValue > 7.1) {
      return "با pH قلیایی";
    }
  }
  if (name === "EC") {
    if (parameterValue > 0 && parameterValue < 2) {
      return "غیر شور";
    }
    if (parameterValue > 2 && parameterValue < 4) {
      return "نسبتاً شور";
    }
    if (parameterValue > 4 && parameterValue < 8) {
      return "شور";
    }
    if (parameterValue > 8 && parameterValue < 16) {
      return "با شوری زیاد";
    }
    if (parameterValue > 16) {
      return "شدیداٌ شور";
    }
  }
};

export const proposition2UiHelper = (persianName, unit, parameterMapInfo) => {
  let max =
      parameterMapInfo?.mapInfo?.ranges[
        parameterMapInfo?.mapInfo?.ranges?.length - 1
      ]?.max,
    min = parameterMapInfo?.mapInfo?.ranges[0]?.min;
  switch (unit) {
    case "(dS/m)":
      unit = "دسی‌زیمنس بر متر";
      break;
    case "%":
      unit = "درصد";
      break;
    case "(mg/kg)":
      unit = "میلی‌گرم بر کیلوگرم";
      break;
    default:
      unit = "";
  }
  if (max === min) {
    return `نقشه ${
      persianName === "هدایت الکتریکی" ? "شوری" : persianName
    } خاک مشخص کرد که مقدار ${
      persianName === "هدایت الکتریکی" ? "شوری" : persianName
    } در کل زمین حدود ${min} ${unit} است.`;
  } else {
    return `نقشه ${
      persianName === "هدایت الکتریکی" ? "شوری" : persianName
    } خاک مشخص کرد که مقدار ${
      persianName === "هدایت الکتریکی" ? "شوری" : persianName
    } زمین از ${min} تا ${max} ${unit} متغیر است.`;
  }
};

export const proposition3UiHelper = (persianName, unit, parameterMapInfo) => {
  switch (unit) {
    case "(dS/m)":
      unit = "دسی‌زیمنس بر متر";
      break;
    case "%":
      unit = "درصد";
      break;
    case "(mg/kg)":
      unit = "میلی‌گرم بر کیلوگرم";
      break;
    default:
      unit = "";
  }
  return `کمترین مقدار ${
    persianName === "هدایت الکتریکی" ? "شوری" : persianName
  } با ${parameterMapInfo?.mapInfo?.ranges[0]?.min} تا ${
    parameterMapInfo?.mapInfo?.ranges[0]?.max
  } ${unit} مربوط به محدوده ${
    parameterMapInfo?.mapInfo?.ranges[0]?.label
  } و بیشترین مقدار با ${
    parameterMapInfo?.mapInfo?.ranges[
      parameterMapInfo?.mapInfo?.ranges?.length - 1
    ]?.min
  } تا ${
    parameterMapInfo?.mapInfo?.ranges[
      parameterMapInfo?.mapInfo?.ranges?.length - 1
    ]?.max
  } ${unit} مربوط به محدوده ${
    parameterMapInfo?.mapInfo?.ranges[
      parameterMapInfo?.mapInfo?.ranges?.length - 1
    ]?.label
  } می‌باشد.`;
};

export const isShowProposition3UiHelper = (parameterMapInfo) => {
  let max =
      parameterMapInfo?.mapInfo?.ranges[
        parameterMapInfo?.mapInfo?.ranges?.length - 1
      ]?.max,
    min = parameterMapInfo?.mapInfo?.ranges[0]?.min;
  if (min > 0 && min < 1) {
    if (max / min < 2) {
      return false;
    }
  }
  if (min > 1 && min < 10) {
    if (max / min < 1.6) {
      return false;
    }
  }
  if (min > 100) {
    if (max / min < 1.15) {
      return false;
    }
  }
  return true;
};

export const proposition4UiHelper = (persianName, unit, parameterMapInfo) => {
  switch (unit) {
    case "(dS/m)":
      unit = "دسی‌زیمنس بر متر";
      break;
    case "%":
      unit = "درصد";
      break;
    case "(mg/kg)":
      unit = "میلی‌گرم بر کیلوگرم";
      break;
    default:
      unit = "";
  }
  let maxPercentage = parameterMapInfo?.mapInfo?.percentage[0];
  let rangeObject = parameterMapInfo?.mapInfo?.ranges[0];
  parameterMapInfo?.mapInfo?.percentage?.forEach((value, i) => {
    if (value > maxPercentage) {
      maxPercentage = value;
      rangeObject = parameterMapInfo?.mapInfo?.ranges[i];
    }
  });
  return `همینطور مساحت غالب زمین با سهم حدود ${maxPercentage} درصد (محدوده ${
    rangeObject?.label
  }) با مقدار ${persianName === "هدایت الکتریکی" ? "شوری" : persianName} ${
    rangeObject?.min
  } تا ${rangeObject?.max} ${unit} مشاهده می‌شود.`;
};

export const isShowProposition4UiHelper = (parameterMapInfo) => {
  const percentageValueMore60 = parameterMapInfo?.mapInfo?.percentage?.some(
    (value) => value > 60
  );
  if (!percentageValueMore60) {
    return false;
  }
  if (parameterMapInfo?.mapInfo?.percentage?.length === 1) {
    return false;
  }
  return true;
};

export const determiningParameterDepth = (depthId) => {
  switch (depthId) {
    case 1:
      return "عمق 30-0";
    case 2:
      return "عمق 60-30";
    case 3:
      return "عمق 90-60";
    default:
      return "عمقی مشخص نشده است";
  }
};

export const academicDegreeDetector = (academicId) => {
  switch (academicId) {
    case 1:
      return "دکتر";
    case 7:
      return "";
    default:
      return "مهندس";
  }
};
